<template>
  <!-- <v-container fluid class="home-page-content mt-12"> -->
  <v-container fluid class="transparent mt-12">
    <v-btn
      text
      color="#900"
      @click.stop="goToHelpPage"
      style="position: fixed; z-index: 5; top: 24px; right: 400px;"
    >
      <v-icon class="mr-2">mdi-help-box</v-icon>
      Help
    </v-btn>

    <v-btn
      v-if="!drawer"
      text
      color="#900"
      @click.stop="drawer = !drawer"
      style="position: fixed; z-index: 5; top: 24px; right: 100px;"
    >
      <v-icon>mdi-calculator</v-icon>
      Calculator
    </v-btn>

    <v-btn
      v-if="dashboard"
      text
      color="#900"
      @click.stop="goToCabinet"
      style="position: fixed; z-index: 5; top: 24px; right: 240px;"
    >
      <v-icon class="mr-2">mdi-monitor-dashboard</v-icon>
      Dashboard
    </v-btn>
    <PortalCalculator :drawer.sync="drawer" :role="role.toLowerCase()" />
  </v-container>
</template>

<script>

import { credentialsHandler, roleHandler } from '@/helpers'

export default {
  name: 'Partner',

  data: () => ({
    drawer: false,
    dashboard: false,
    role: roleHandler()
  }),

  methods: {
    goToHelpPage () {
      this.$openExternalLink('https://dgtek.net/portal-help')
    },

    goToCabinet () {
      sessionStorage.setItem('role', roleHandler())
      sessionStorage.setItem('creds', credentialsHandler())
      const link = location.origin.indexOf('portal') >= 0 ? location.origin : 'http://192.168.0.101:8082' /* for development mode only */
      this.$openInternalLink(`${link}/rsp#${credentialsHandler()}`, '_self')
    }
  },

  mounted () {
    if (!roleHandler() || !credentialsHandler()) {
      roleHandler(sessionStorage.getItem('role') || 'visitor')
      credentialsHandler(sessionStorage.getItem('creds') || '')
    }
    this.dashboard = roleHandler() === 'RSP' && credentialsHandler()
  }
}
</script>

<style>
.home-page-content {
  height: 100vh;
  background: transparent;
  background-image: url(../assets/images/melbourne-2-1.svg);
  background-position: center;
  background-size:cover;
}
</style>
